export default "__VITE_ASSET__CN$Dy4AC__"